import { Col, Row } from "react-bootstrap";
import HighlightBox from "../../lib/highlight-box";
import React from "react";
import { sum } from "lodash/math";
import isEmpty from "lodash/isEmpty";
import { formatMoney } from "../../../lib/format-money";
import { hummanizeNumber } from "../../../lib/numbers";

const CampaignPageMetaData = props => {
  const { acceptedPlusItems = [], campaignStats } = props;

  if (isEmpty(campaignStats)) return false;
  const totalDownloads = campaignStats.totalDownloads ?? 0;

  const totalBudget = sum(acceptedPlusItems.map(item => item.totalBudget));

  return (
    <>
      <Row>
        <Col xs={12} md={3}>
          <HighlightBox title="total budget" value={formatMoney(totalBudget)} />
        </Col>
        <Col xs={12} md={3}>
          <HighlightBox
            title="total paid"
            value={formatMoney(campaignStats.totalPaidByAdvertiser)}
          />
        </Col>
        <Col xs={12} md={3}>
          <HighlightBox title="Total Podcasts" value={acceptedPlusItems.length} />
        </Col>
        <Col xs={12} md={3}>
          <HighlightBox title="total downloads" value={hummanizeNumber(totalDownloads)} />
        </Col>
      </Row>
    </>
  );
};

export default CampaignPageMetaData;
